import { isArray, isObject, mapKeys, mapValues, camelCase } from 'lodash'

export const toCamelCase = (object: Object): Object => {
  if (isArray(object)) {
    return object.map(toCamelCase)
  } else if (isObject(object)) {
    return mapKeys(mapValues(object, toCamelCase), (_value, key) => camelCase(key))
  } else {
    return object
  }
}
